import { getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import 'twin.macro';
import { ModalHeader } from './common';
import { memo } from 'react';
import { useTranslation } from 'next-i18next';
export const TokenVerificationProgressingContent = memo(() => {
  const { t } = useTranslation('user-settings');
  const modalHeaderText = t('email_token_verification_in_progress');
  return (
    <div tw="flex flex-col gap-4 w-full lg:min-h-[15.625rem] min-h-[19.438rem] justify-center items-center ">
      <Image
        src={getAssetSrc('/utils-assets/progress.svg')}
        width={48}
        height={48}
        alt={modalHeaderText}
        tw="animate-spin"
      />
      <ModalHeader>{modalHeaderText}</ModalHeader>
    </div>
  );
});
